import { atom, selector } from 'recoil'

import { regexEmail } from 'mailup-react-helpers'

import {
  TRUSTED_SENDER_STATUS_CONFIRMED,
  TRUSTED_SENDER_STATUS_DELIVER_ERROR,
  TRUSTED_SENDER_STATUS_DELIVER_ISP,
  TRUSTED_SENDER_STATUS_DELIVER_OK,
  TRUSTED_SENDER_STATUS_DELIVER_WARN,
  TRUSTED_SENDER_STATUS_NO_DELIVER
} from 'Api/beSendGoApi'
import { trustedEmailSenderState } from 'Hooks/useTrustedEmailSender'
import {
  PARAM_ORDER_ASC,
  PROGRESSBAR_VARIANT_DEFAULT
} from 'mailup-web-components'

import { PECPLUS_STATUS_COMPLETE_DESCR } from 'Constants'
import { RECIPIENTS_NONE } from 'Pages/AbTestWizard/const'

import { ABTEST_STATUS_ERROR } from 'Api/beABTestApi'
import { BEQUEUE_CONFIG_STATE_RUNNING } from 'Api/beQueueApi'
import { isValidDateState } from 'Components/ContentScheduled/recoil/state'
import getIntl from 'Helpers/intl'

export const abTestState = atom({
  key: 'AbTestWizardState',
  default: {
    id: 0,
    stato: null,
    step1: {
      init: true,
      step1IsDirty: false,
      name: '',
      nameIsDiry: false,
      abTestMessages: [],
      percTest: 20,
      tipoTest: '',
      criterio: 1,
      tags: [],
      changeHistory: undefined
    },
    step2: {
      step2IsDirty: false,
      idTestDefault: undefined,
      recipients: RECIPIENTS_NONE,

      senderInfo: {
        isPEC: false,
        pecPlusStatus: undefined,
        // queueStatus: undefined,
        // idAsyncQueueConfig: undefined,
        // queued: undefined,
        senderName: undefined,
        senderNameIsDiry: false,
        senderEmail: undefined,
        replyToEmail: undefined,
        replyToEmailIsDirty: false,
        customSender: false,
        // idFieldSenderNameMail: undefined,
        // idSenderEmailField: undefined,
        // lastSendingId: undefined,
        fetchedSender: false,
        invalidReplyTo: false,
        customEmailValue: 0,
        customEmaiLabel: null,
        customNameValue: 0,
        customNameLabel: null,
        customEmailValueIsDirty: false,
        customNameValueIsDirty: false
        // sendingOrScheduleId: undefined,
      }
    },
    step3: {
      trialRecipientLimit: false,
      step3IsDirty: false,
      includeGroups: [],
      excludeGroups: [],
      selectedFilters: [],
      typeAppliedFilters: 'All'
    },
    step4: {
      loaded: false,
      step4IsDirty: false,
      idAsyncQueueConfig: null,
      queueStatus: BEQUEUE_CONFIG_STATE_RUNNING,
      variant: PROGRESSBAR_VARIANT_DEFAULT,
      toBeQueued: 0,
      queued: 0,
      queuedPercentage: 0,
      winningMessage: {},
      status: undefined,
      processGlobalStatus: undefined,
      totalRecipients: 0,
      overallPercentage: 0,
      abTestMessages: [],
      progressNumber: 0,
      totPB: 0,
      changeHistory: undefined,
      dateModel: {
        date: new Date().toISOString(),
        hour: '',
        minute: '',
        utcDate: new Date().toISOString(),
        timeZoneCode: '',
        validHour: true,
        validMinutes: true,
        validDate: true,
        boxError: false,
        showFeedback: false
      },
      winnerScheduling: 4
    }
  }
})

export const tagsListState = atom({
  key: 'abtestTagsListState',
  default: {
    tagsList: []
  }
})

const validSenderStatus = [
  TRUSTED_SENDER_STATUS_CONFIRMED,
  TRUSTED_SENDER_STATUS_NO_DELIVER,
  TRUSTED_SENDER_STATUS_DELIVER_OK,
  TRUSTED_SENDER_STATUS_DELIVER_ERROR,
  TRUSTED_SENDER_STATUS_DELIVER_WARN,
  TRUSTED_SENDER_STATUS_DELIVER_ISP
]

const validEmailRe = new RegExp(regexEmail)

export const isValidStep4Satate = selector({
  key: 'AbTestWizardValidStep4',
  get: ({ get }) => {
    const { step4, stato, step1 } = get(abTestState)
    const isValidDate = get(isValidDateState)

    if (step4.winnerScheduling < 1 && step1.tipoTest === 'A') {
      return false
    }

    if (!isValidDate) {
      return false
    }
    // if (!step4.dateModel.validDate) {
    //   return false
    // }

    // if (
    //   typeof step4.dateModel.hour !== 'number' ||
    //   !step4.dateModel.validHour
    // ) {
    //   return false
    // }
    // if (
    //   typeof step4.dateModel.minute !== 'number' ||
    //   !step4.dateModel.validMinutes
    // ) {
    //   return false
    // }
    if (stato === ABTEST_STATUS_ERROR) {
      return false
    }

    if (step4.overallPercentage !== 100) {
      return false
    }

    if (!step4.loaded) {
      return false
    }

    return true
  }
})

export const isValidFormState = selector({
  key: 'AbTestWizardEnableValidForm',
  get: ({ get }) => {
    const { step2 } = get(abTestState)

    const { status: senderStatus } = get(
      trustedEmailSenderState('trustedSender')
    )

    const validSender = step2.senderInfo.isPEC
      ? step2.senderInfo.pecPlusStatus === PECPLUS_STATUS_COMPLETE_DESCR
      : validSenderStatus.includes(senderStatus)

    if (!step2.senderInfo.senderEmail) {
      return false
    } else if (!step2.senderInfo.senderName) {
      return false
    } else if (!step2.senderInfo.senderEmail) {
      return false
    } else if (!step2.senderInfo.replyToEmail) {
      return false
    } else if (!validEmailRe.test(step2.senderInfo.senderEmail)) {
      return false
    } else if (!validEmailRe.test(step2.senderInfo.replyToEmail)) {
      return false
    } else if (!validSender) {
      return false
    } else if (step2.senderInfo.customSender) {
      if (!step2.senderInfo.customEmailValue) {
        return false
      }
      if (!step2.senderInfo.customNameValue) {
        return false
      }
    }

    return true
  }
})

export const dynamicOptionsState = atom({
  key: 'abtestdynamicOptionsState',
  default: {
    dynamicOptions: []
  }
})

export const searchCriteriaState = atom({
  key: 'searchAbTestCriteriaState',
  default: {
    loading: false,
    loaded: false,
    error: false,
    severity: 'danger',
    groups: [],
    filters: []
  }
})

export const dynamicFieldsState = atom({
  key: 'searchAbTesWizardDynamicFieldsState',
  default: []
})

export const recipientsDataTablePreviewState = atom({
  key: 'AbTesWizardrecipientsDataTablePreviewState',
  default: {
    loading: false,
    loaded: false,
    firstChange: true,
    items: undefined,
    sortBy: 'Email',
    sortOrder: PARAM_ORDER_ASC,
    sortChanged: false
  }
})

export const sendingPreviewState = atom({
  key: 'AbTesWizardSendingPreviewState',
  default: {
    loading: false,
    loaded: false,
    showLoading: false,
    error: undefined,
    severity: undefined,
    queued: undefined,
    excludedGroups: [],
    toBeQueued: undefined,
    totalRecipients: undefined,
    diff: undefined,
    oldIncludeGroups: undefined,
    oldExcludeGroups: undefined,
    oldSelectedFilters: undefined,
    previewLoading: false
  }
})

export const visibleColumnsState = atom({
  key: 'AbTesWizardSearchRecipientsVisibleColumnsState',
  default: []
})

export const fixedFieldsState = selector({
  key: 'AbTesWizardSearchRecipientsFixedFieldsState',
  get: ({ get }) => {
    return [
      {
        id: 'Email',
        description: getIntl().formatMessage({
          id: 'Load.SearchRecipients.emailHeading'
        })
      },
      {
        id: 'MobilePrefixAndNumber',
        description: getIntl().formatMessage({
          id: 'Load.SearchRecipients.smsHeading'
        })
      }
    ]
  }
})

export const manageableFieldsState = selector({
  key: 'searchAbTestWizardManageableFieldsState',
  get: ({ get }) => {
    const staticFields = [
      {
        id: 'Email',
        description: getIntl().formatMessage({
          id: 'Load.SearchRecipients.emailHeading'
        })
      },
      {
        id: 'MobilePrefixAndNumber',
        description: getIntl().formatMessage({
          id: 'Load.SearchRecipients.smsHeading'
        })
      }
    ]

    const dynamicFields = get(dynamicFieldsState).map(
      ({ Id, Description }) => ({
        id: typeof Id === 'number' ? `Field${Id}` : Id,
        description: `${Id} - ${Description}`
      })
    )

    return [...staticFields, ...dynamicFields]
  }
})

export const progressState = atom({
  key: 'AbTEstSendingWizardProgressBarState',
  default: {
    loading: false,
    loaded: false,
    queueStatus: BEQUEUE_CONFIG_STATE_RUNNING,
    variant: 'default',
    toBeQueued: 0,
    queued: 0,
    queuedPercentage: 0,
    bandwidth: undefined,
    sendMethodType: undefined,
    estimatedSendingTime: undefined
  }
})

export const step1State = selector({
  key: 'step1StateState',
  get: ({ get }) => {
    const { step1 } = get(abTestState)
    return step1
  }
})

export const step4State = selector({
  key: 'step4StateState',
  get: ({ get }) => {
    const { step4 } = get(abTestState)
    return step4
  }
})

export const step3State = selector({
  key: 'step3StateState',
  get: ({ get }) => {
    const { step3 } = get(abTestState)
    return step3
  }
})
